<div
  class="flex justify-center items-center mt-5 lg:mt-0 ml-5 mr-5 flex-col lg:flex-row"
>
  <mat-card class="w-fit text-center">
    <div class="flex flex-row items-center">
      <div class="h-full flex flex-col">
        <mat-card-header class="w-full justify-center">
          @if(myUser && myUser.user) {
          <mat-card-title class="mb-10">
            Welcome {{ myUser.user.firstName }}
            {{ myUser.user.lastName }}</mat-card-title
          >
          } @if(myUser == undefined || myUser.user == undefined) {
          <mat-card-title class="mb-10"> Welcome Admin</mat-card-title>
          }
        </mat-card-header>

        <mat-card-content>
          <div class="flex justify-self-center mt-2 w-2/3">
            Manage administrators, vendors, colleges, and posts, approve or
            reject new vendor requests and view all posts on Bizi Buzz.
          </div>

          <div class="flex justify-center mt-5">
            <button
              mat-raised-button
              color="accent"
              class="w-1/3 mr-2"
              routerLink="/admins"
            >
              Manage Administrators
            </button>
            <button
              mat-raised-button
              color="accent"
              class="w-1/3"
              routerLink="/vendors"
            >
              Manage Vendors
            </button>
          </div>

          <div class="flex justify-center mt-2">
            <button
              mat-raised-button
              color="accent"
              class="w-1/3 mr-2"
              routerLink="/users"
            >
              Manage Users
            </button>

            <button
              mat-raised-button
              color="accent"
              class="w-1/3"
              routerLink="/posts"
            >
              Manage Posts
            </button>
          </div>

          <div class="flex justify-center mt-2">
            <button
              mat-raised-button
              color="accent"
              class="w-1/3 mr-2"
              routerLink="/colleges"
            >
              Manage Colleges
            </button>

            <button
              mat-raised-button
              color="accent"
              class="w-1/3"
              routerLink="/campuses"
            >
              Manage Campuses
            </button>
          </div>
        </mat-card-content>
      </div>
    </div>
  </mat-card>

  <div class="w-1/2 lg:w-1/3">
    <img src="assets\Circle Logo - White Background.png" />
  </div>
</div>
